// extracted by mini-css-extract-plugin
module.exports = {"flex":"StatusChip_flex__2jch-","online":"StatusChip_online__HZuxs","offline":"StatusChip_offline__3VUdF","buffer":"StatusChip_buffer__1yWHq"};